export const updateFavicon = (page) => {
  const faviconSVG = document.querySelector("link[rel='icon'][type='image/svg+xml']");
  const appleIcon = document.querySelector("link[rel='apple-touch-icon']");
  
  let iconPath;
  switch (page) {
    case 'colorz':
      iconPath = '/favicon-colorz.svg';
      break;
    case 'random':
      iconPath = '/favicon-random.svg';
      break;
    case 'memory':
      iconPath = '/favicon-memory.svg';
      break;
    case 'compare':
      iconPath = '/favicon-compare.svg';
      break;
    default:
      iconPath = '/favicon-colorz.svg';
  }
  
  if (faviconSVG) {
    faviconSVG.href = iconPath;
  }
  if (appleIcon) {
    appleIcon.href = iconPath;
  }
};
